<H2>Showresultaten</H2>
<table mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="showYear">
    <th mat-header-cell *matHeaderCellDef>Jaar</th>
    <td mat-cell *matCellDef="let element">
      {{ element.alpacashow.showYear }}
    </td>
  </ng-container>

  <ng-container matColumnDef="result">
    <th mat-header-cell *matHeaderCellDef>Plaatsing</th>
    <td mat-cell *matCellDef="let element">{{ element.result }}</td>
  </ng-container>

  <ng-container matColumnDef="showname">
    <th mat-header-cell *matHeaderCellDef>Alpacashow</th>
    <td mat-cell *matCellDef="let element">
      {{ element.alpacashow.showName }} {{ element.alpacashow.location }}
      @if(element.alpacashow.judges.length > 0) {
      <div>
        Jury:
        @for(judge of element.alpacashow.judges; track judge; let last = $last) {
          <span>
          {{ judge.name  }}{{ last ? "" : ", " }}
          </span>
        }
      </div>
      }
      @if(element.alpacashow.showDates.length > 0) {
      <div>
        Datum:
        @for(showDate of element.alpacashow.showDates; track showDate; let last = $last) {
          <span>
            {{ showDate.date | date : "dd-MM-yyyy" }}{{ last ? "" : ", " }}
          </span>
        }
      </div>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>


